import { globalVariables } from "./globalVariables";
export const dogStatus = [
  globalVariables.active,
  globalVariables.deceased,
  globalVariables.retired,
];
